import { PlaybackGuard } from '@app/core/playback/context/PlaybackGuard';
import { Suspense } from 'react';
import { useFragment } from '../../../hooks/useFragment';
import { TranscriptionContent } from './TranscriptionContent';
import { TranscriptionLoading } from './state/TranscriptionLoading';
import { TranscriptionSkeleton } from './state/TranscriptionSkeleton';

/**
 * Renders transcription loading state or the v2 transcript UI when media and transcription are ready.
 */
export function TranscriptionView() {
  const { fragment } = useFragment();

  if (!fragment.mediaCompletedAt || !fragment.transcriptionCompletedAt) {
    return <TranscriptionLoading />;
  }

  return (
    <PlaybackGuard>
      <Suspense fallback={<TranscriptionSkeleton rowCount={12} />}>
        <TranscriptionContent />
      </Suspense>
    </PlaybackGuard>
  );
}
